<div class="map-poi">

    <!-- None tamale entity-->
    <div class="poi-header">
        <div *ngIf="showUIIndex===1" class="address-info">
            <div>{{marker.entityName}}</div>
            <span>{{marker.address}}</span>
        </div>

        <div *ngIf="showUIIndex===2" class="address-info">
            <span class="color-link hover-link" (click)="showContactDetail(marker)">{{marker.entityName}}<label
                    class="name-type">{{marker.entityType}}</label></span>
            <div class="address">
                <span>{{marker.addressType}} Address:&nbsp;</span>
                <a>{{contactAddress}}</a>
            </div>
            <span *ngIf="!marker.detail||(marker.detail&&marker.detail.webPhone.length===0)">Phone:&nbsp;</span>
            <div *ngIf="marker.detail&&marker.detail.webPhone.length>0">
                <div *ngFor="let item of marker.detail.webPhone">
                    <div class="address">
                        <span>{{item.name}} Phone:&nbsp;</span>
                        <a>{{item.phone}}</a>
                    </div>
                </div>
            </div>
            <div class="address">
                <span>Pirmary Email:&nbsp;</span>
                <a *ngIf="marker.detail">{{marker.detail.primaryEmail}}</a>
            </div>
        </div>

        <div *ngIf="showUIIndex===3" class="address-info">
            <span class="color-link hover-link" (click)="showContactDetail(marker)">{{marker.entityName}}<label
                    class="name-type">{{marker.entityType}}</label></span>
            <div class="address address-entity">
                <span>{{marker.addressType}}:</span>
                <a>{{marker.address}}</a>
            </div>
            <div class="address address-entity">
                <span>Phone:</span>
                <a *ngIf="marker.detail&&marker.detail.detail">{{marker.detail.detail.phone}}</a>
            </div>
        </div>

        <div *ngIf="showUIIndex===4" class="address-info">
            <div *ngFor="let item of duplicateAddress">
                <span class="duplicate-address">{{item.address}}</span>
                <div *ngFor="let data of item.list">
                    <span class="color-link hover-link multiple-entity"
                        (click)="showContactDetail(data)">{{data.entityName}} ({{data.entityType}})</span>
                </div>
            </div>
        </div>

        <div *ngIf="showUIIndex===5" class="event-info">
            <div class="item-row first">
                <div class="subject-area">
                    <span class="subject-value">{{marker.entityName}}</span>
                </div>
            </div>
            <div class="item-row second">
                <div class="entities-area">
                    <span class="entities-value" *ngFor="let item of marker.eventProperties.entities"
                        [title]="item.shortName">
                        <span class="entity-value">{{item.shortName}}</span>
                    </span>
                </div>
            </div>
            <div class="item-row third">
                <div class="entry-type-area">
                    <span class="entry-type-value">{{marker.eventProperties.eventType}}</span>
                </div>
            </div>
            <div class="item-row fouth">
                <div class="date-area">
                    <smart-icon name="calendar" class="date"></smart-icon>
                    <span class="date-value">{{marker.eventProperties.date}}</span>
                </div>
            </div>
            <div class="item-row fifth">
                <div class="particpants-area">
                    <smart-icon name="users-o" class="particpants-icon"></smart-icon>
                    <div class="particpants-value-container">
                        <span class="particpants-values"
                            *ngFor="let item of marker.eventProperties.particpants;let last=last;trackBy:trackByFn">{{item["short-name"]}}{{last
                            ? '' : '; '}}</span>
                    </div>
                </div>
            </div>
            <div class="item-row sixth">
                <div class="location-info">
                    <div class="location-area" kendoTooltip position="bottom">
                        <smart-icon name="location" class="location">
                        </smart-icon>
                        <span class="location-value">{{marker.eventProperties.location}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="poi-footer">
        <div class="poi-icon" *ngIf="!isShowEventOnMap">
            <smart-icon *ngIf="!marker.isAddStop" title="Get direction" class="direction-curve" name="direction-curve"
                (click)="directToMapTrip()">
            </smart-icon>
            <smart-icon *ngIf="!marker.isAddStop" title="Search nearby" class="search" name="direction-nearby"
                (click)="searchNearby()">
            </smart-icon>
            <smart-icon *ngIf="marker.isAddStop" title="Add stop" class="search" name="add-stop"
                (click)="addStopToMapTrip()">
            </smart-icon>
        </div>
        <span class="view-google" (click)="viewOnGoogleMap()">View on Google Map</span>
    </div>

</div>